import { MessageConst } from 'enums'
import { isNumber } from 'lodash'

export type ChartValue = number | string
// TODO: this type is too restrictive to keep developing, add it back once all uncertainties are clarified ?
// export type ChartValue = number | typeof MessageConst.EM_DASH

export const isValidNumber = (value: ChartValue | undefined): value is number =>
  isNumber(value) && !Number.isNaN(value)

export const inValidNumberToZero = (value: ChartValue) => (isValidNumber(value) ? value : 0)

export const calcTotal = (values: ChartValue[]) =>
  values.map(inValidNumberToZero).reduce((a, b) => a + b, 0)

export const calPercent = (value: ChartValue, total: number) => {
  if (!isValidNumber(value) || !isValidNumber(total)) {
    return MessageConst.EM_DASH
  }
  if (total === 0) {
    return 0
  }
  return value / total
}
